import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteRejectAtom = createMutationAtomFactory(
  'brokerage.quoteReject',
  (params: { id: string }) => ({
    tradeQuoteReject: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
